import { useQuery } from '@tanstack/react-query';

import { fetchCustomers } from '../../../api/services/customer/customerService';
import { Customer } from '../../../common/interfaces/customers/customers';

export const useCustomers = () => {
  const { data, error, isLoading } = useQuery<Customer[], Error>({
    queryKey: ['customers'],
    queryFn: fetchCustomers,
  });
  return { data, error, isLoading };
};
